import React from "react";
import { CardElement } from "@stripe/react-stripe-js";

import useErrorConsumer from "@kikoff/hooks/src/useErrorConsumer";

import { ErrorPanel } from "@component/errors";

import styles from "./styles.module.scss";

interface PaymentMethodEntryProps {
  onValidChange(valid: boolean): void;
  hideErrorPanel?: boolean;
}

function PaymentMethodEntry({
  onValidChange,
  hideErrorPanel = false,
}: PaymentMethodEntryProps) {
  const error = useErrorConsumer();

  return (
    <div className={styles["payment-method-entry"]}>
      <CardElement
        className={styles["card-input"]}
        onChange={({ complete }) => {
          onValidChange(complete);
        }}
      />
      {!hideErrorPanel && (
        <ErrorPanel
          // @ts-expect-error
          className={styles.error}
          message={error.message}
          onClose={error.hide}
          show={error.show}
        />
      )}
    </div>
  );
}

export default PaymentMethodEntry;
